if (!customElements.get('q-coffee-finder')) {
  customElements.define('q-coffee-finder', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.brew = null;
      this.querySelector('.q2-finder-interactive').hidden = false;
      this.addEventListener('click', (event) => {
        const button = event.target.closest('button');
        if (!button || !this.contains(button)) return;
        if (button.hasAttribute('data-restart') || button.hasAttribute('data-back')) {
          this.brew = null;
          this.querySelector('[data-result-content]').replaceChildren();
          this.showStep('brew');
        } else if (button.dataset.brew) {
          this.brew = button.dataset.brew;
          this.querySelectorAll('[data-taste-group]').forEach(group => {
            group.hidden = group.dataset.tasteGroup !== (this.brew === 'drip' ? 'drip' : 'beans');
          });
          if (this.brew === 'arabic') this.showResult('any');
          else this.showStep('taste');
        } else if (button.dataset.taste && this.brew) this.showResult(button.dataset.taste);
      });
    }
    showStep(step) {
      this.querySelectorAll('[data-step]').forEach(panel => { panel.hidden = panel.dataset.step !== step; });
      this.querySelector('[data-restart]').hidden = step === 'brew';
      this.querySelector('[data-progress]').textContent = step === 'brew' ? '01 / 02' : step === 'taste' ? '02 / 02' : 'YOUR COFFEE / اختيارك';
      const heading = this.querySelector(`[data-step="${step}"] h3`);
      heading.focus({ preventScroll: true });
      if (this.getBoundingClientRect().top < 0) this.scrollIntoView({ block: 'start', behavior: 'auto' });
    }
    showResult(taste) {
      const template = [...this.querySelectorAll('template[data-result]')].find(item => item.dataset.result === `${this.brew}-${taste}`);
      const target = this.querySelector('[data-result-content]');
      target.replaceChildren();
      if (template) target.append(template.content.cloneNode(true));
      else {
        const message = document.createElement('p');
        message.textContent = 'تواصل معنا لمساعدتك في اختيار قهوتك. Contact us for a personal coffee recommendation.';
        target.append(message);
      }
      this.showStep('result');
      this.querySelector('[data-finder-status]').textContent = 'اقتراحك جاهز. Your coffee recommendation is ready.';
    }
  });
}
